import { AxiosError } from 'axios';
import { newrelic } from './newrelic';

const AXIOS_ERROR_SUPPORT_MAPPING = {
  ERR_NETWORK: 'E001',
  ECONNREFUSED: 'E002',
  ECONNRESET: 'E003:',
  ETIMEDOUT: 'E004',
  ECONNABORTED: 'E005',
  ERR_CANCELED: 'E006',
  ERR_TIMEDOUT: 'E007',
  ERR_TLS_CERT_ALTNAME_INVALID: 'E008',
  ERR_CERT_DATE_INVALID: 'E009',
  ERR_BAD_OPTION_VALUE: 'E010',
  ERR_BAD_OPTION: 'E011',
  ERR_BAD_RESPONSE: 'E012',
  ERR_BAD_REQUEST: 'E013',
  ERR_NOT_SUPPORT: 'E014',
  ERR_INVALID_URL: 'E015',
  ERR_FR_TOO_MANY_REDIRECTS: 'E016',
  ERR_DEPRECATED: 'E017',
  SERVICE_UNAVAILABLE: 'E018',
  ERR_BAD_GATEWAY: 'E019'
};

type Code = keyof typeof AXIOS_ERROR_SUPPORT_MAPPING;

/**
 * Maps an Axios error to a predefined error code for customer support purposes.
 * @param error AxiosError instance
 * @returns Corresponding error code as a string
 */
export function mapAxiosErrorToSupportCode(error: AxiosError): string | null {
  if (error.response?.status === 503) {
    const code = AXIOS_ERROR_SUPPORT_MAPPING.SERVICE_UNAVAILABLE;
    newrelic.log('network error', { customAttributes: { code }, level: 'ERROR' });
    return code;
  }

  // Except for status 503, we only want to map network errors
  if (error.response) return null;
  if (!error.code) return null;

  const code = AXIOS_ERROR_SUPPORT_MAPPING[error.code as Code];
  if (!code) return null;
  newrelic.log('network error', { customAttributes: { code }, level: 'ERROR' });
  return code;
}
